<template>
    <article
      class="hero-article"
      :class="$route.name">

      <h1
        :class="`h1-hero-${$route.name}`"
        :style="{'color' : (isDark ? 'white' : '') }"
        v-html="title">
          {{title}}
        </h1>
      <p
        :class="`p-hero-${$route.name}`"
        :style="{'color' : (isDark ? 'white' : '') }">{{text}}</p>
      <p
        v-if="intro">
        <small>{{intro}}</small>
      </p>

    <StartForm
      v-if="!ctaIsHidden"
      container="hero" />
    
  </article>
</template>

<script>
import StartForm from '@/components/form/StartForm.vue'

export default {
  name: 'hero',
  props: {
    title: String,
    text: String,
    text1: String,
    text2: String,
    displayInput: Boolean,
    intro: String,
    isDark: Boolean,
    bgImg: String
  },
  components: {
    StartForm
  },
  computed: {
    ctaIsHidden: function() {
      return this.$route.name === 'services-archives' || 
      this.$route.name === 'contacts' ||
      this.$route.name === 'about'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/_mixins.scss';

  article {
    @include grid-padding;

    h1 {
      text-align: center;
        margin-bottom: $default_vmin;
      }

    @include respond-to(desktop) {
      margin-bottom: $small_vmin;
      padding-left: 0;
      @include grid(12);

      h1 {
        grid-column: 2 / span 10;
        align-self: end;
      }

      p {
        grid-column: 2 / span 10;

        @include respond-to(tv) {
          font-size: 200%;
        }
      }

      form {
        grid-column: 1 / span 12;
      }
    }

    @include respond-to(tv) {

      h1 {
        grid-column: 3 / span 8;
        // padding: $default_vmin $big_vmin;
      }

      p {
        grid-column: 3 / span 8;
      }

      form {
        grid-column: 3 / span 8;
      }
    }

    &:not(.home) {
      @include respond-to(desktop) {
        min-height: 30vh;
      }
    }
  }
</style>

